export default (theme) => ({
    activeBottomTab: {
        backgroundColor: `${theme.palette.tabButtons.active} !important`,
        color: `${theme.palette.tabButtons.activeText} !important`,
    },
    activeListButton: {
        backgroundColor: `${theme.palette.tabButtons.active} !important`,
        color: `${theme.palette.tabButtons.activeText} !important`,
    },
    assetListHeading: {
        backgroundColor: theme.palette.assetListHeading.default,
        borderBottom: `1px solid ${theme.palette.border.lightBorder}`,
        padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    },
    active: {
        color: theme.palette.assetListHeading.net,
    },
    assetListButtonsContainer: {
        padding: theme.spacing(1.5),
    },
    assetListButtons: {
        backgroundColor: theme.palette.tabButtons.default,
        borderRadius: "4px",
        color: theme.palette.tabButtons.defaultText,
        width: "50%",
    },
    buttonTab: {
        backgroundColor: theme.palette.background.lightBackground,
        maxWidth: "50%",
    },
    bottomContainer: {
        borderTop: `1px solid ${theme.palette.border.primary}`,
        bottom: "0",
        position: "fixed",
        width: "100%",
    },
    iconColor: {
        color: `${theme.palette.iconsColor.primary} !important`,
    },
    netConnected: {
        verticalAlign: "top",
        color: theme.palette.text.darkText,
        margin: `0 ${theme.spacing(1)}`,
    },
    tabContainer: {
        width: "100%",
    },
    tabPanelContainer: {
        padding: 0,
    },
    chip: {
        backgroundColor: "transparent",
        color: theme.palette.text.darkText,
        height: "auto",
    },
    alignGrid: {
        alignSelf: "center",
    },
    loadingState: {
        display: "flex",
        justifyContent: "right",
        alignItems: "baseline",
    },
    modalBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        borderRadius: `${theme.spacing(1)}`,
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        width: "90%",
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalMessage: {
        whiteSpace: "break-spaces",
        textAlign: "justify",
        margin: theme.spacing(2),
    },
    modalActions: {
        "& > Button": {
            margin: theme.spacing(1),
        },
    },
    syncIcon: {
        color: theme.palette.info.main,
        width: "1em !important",
        height: "1em !important",
    },
    bottomNavPaper: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
    },
});
